import React, { useState, useEffect } from "react";
import Button from "../Button";
import Tray from "./Tray";
import ReactModal from "react-modal";

const customStyles = {
  overlay: {
    zIndex: 999999999,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 10,
    borderColor: "#",
    maxHeight: "90vh",
    minWidth: "60vw",
    overflowY: "scroll",
  },
};

export default function SingleTrayModal({ tray, reloadTray, onClose }) {
  return (
    <ReactModal
      isOpen={true}
      ariaHideApp={false}
      onRequestClose={onClose}
      style={customStyles}
    >
      <Button title="Close" icon="fa-times" onClick={onClose} />
      <Tray
        tray={tray}
        active
        style={{ marginBottom: 0 }}
        reloadTray={reloadTray}
        removeTray={reloadTray}
      />
    </ReactModal>
  );
}
